/* USDO region
   One shared "where am I shipping to" for the whole storefront.
   Owns the ZIP to state table, the stored region, and the header bar UI.
   Other scripts read window.USDORegion and listen for the "usdo:region" event. */
(function () {
  if (window.USDORegion) return;

  var KEY = "usdo_region";
  var LEGACY_KEY = "usdo_zip";

  var RANGES = [[5,5,"NY"],[6,9,"PR"],[10,27,"MA"],[28,29,"RI"],[30,38,"NH"],[39,49,"ME"],[50,59,"VT"],
    [60,69,"CT"],[70,89,"NJ"],[100,149,"NY"],[150,196,"PA"],[197,199,"DE"],[200,205,"DC"],[206,219,"MD"],
    [220,246,"VA"],[247,268,"WV"],[270,289,"NC"],[290,299,"SC"],[300,319,"GA"],[320,349,"FL"],[350,369,"AL"],
    [370,385,"TN"],[386,397,"MS"],[398,399,"GA"],[400,427,"KY"],[430,459,"OH"],[460,479,"IN"],[480,499,"MI"],
    [500,528,"IA"],[530,549,"WI"],[550,567,"MN"],[570,577,"SD"],[580,588,"ND"],[590,599,"MT"],[600,629,"IL"],
    [630,658,"MO"],[660,679,"KS"],[680,693,"NE"],[700,714,"LA"],[716,729,"AR"],[730,732,"OK"],[733,733,"TX"],
    [734,749,"OK"],[750,799,"TX"],[800,816,"CO"],[820,831,"WY"],[832,838,"ID"],[840,847,"UT"],[850,865,"AZ"],
    [870,884,"NM"],[885,885,"TX"],[889,898,"NV"],[900,961,"CA"],[967,968,"HI"],[970,979,"OR"],[980,994,"WA"],
    [995,999,"AK"]];

  var NAMES = {AL:"Alabama",AZ:"Arizona",AR:"Arkansas",CA:"California",CO:"Colorado",CT:"Connecticut",
    DE:"Delaware",DC:"Washington DC",FL:"Florida",GA:"Georgia",ID:"Idaho",IL:"Illinois",IN:"Indiana",
    IA:"Iowa",KS:"Kansas",KY:"Kentucky",LA:"Louisiana",ME:"Maine",MD:"Maryland",MA:"Massachusetts",
    MI:"Michigan",MN:"Minnesota",MS:"Mississippi",MO:"Missouri",MT:"Montana",NE:"Nebraska",NV:"Nevada",
    NH:"New Hampshire",NJ:"New Jersey",NM:"New Mexico",NY:"New York",NC:"North Carolina",ND:"North Dakota",
    OH:"Ohio",OK:"Oklahoma",OR:"Oregon",PA:"Pennsylvania",RI:"Rhode Island",SC:"South Carolina",
    SD:"South Dakota",TN:"Tennessee",TX:"Texas",UT:"Utah",VT:"Vermont",VA:"Virginia",WA:"Washington",
    WV:"West Virginia",WI:"Wisconsin",WY:"Wyoming"};

  var OFFSHORE = {AK:"Alaska",HI:"Hawaii",PR:"Puerto Rico"};

  function zipToState(z) {
    var d = String(z || "").replace(/\D/g, "");
    if (d.length < 5) return null;
    var p = parseInt(d.slice(0, 3), 10);
    for (var i = 0; i < RANGES.length; i++) {
      if (p >= RANGES[i][0] && p <= RANGES[i][1]) return RANGES[i][2];
    }
    return null;
  }

  function write(o) {
    try { localStorage.setItem(KEY, JSON.stringify(o)); } catch (e) {}
  }

  function read() {
    try {
      var raw = localStorage.getItem(KEY);
      if (raw) {
        var o = JSON.parse(raw);
        if (o && o.state && (NAMES[o.state] || OFFSHORE[o.state])) return o;
      }
      // Carry over anything saved by the earlier product-page-only version.
      var legacy = localStorage.getItem(LEGACY_KEY);
      if (legacy) {
        var st = zipToState(legacy);
        if (st) {
          var mig = { zip: String(legacy).replace(/\D/g, "").slice(0, 5), state: st, ts: Date.now() };
          write(mig);
          return mig;
        }
      }
    } catch (e) {}
    return null;
  }

  var current = read();

  function broadcast() {
    var ev;
    try {
      ev = new CustomEvent("usdo:region", { detail: current });
    } catch (e) {
      ev = document.createEvent("CustomEvent");
      ev.initCustomEvent("usdo:region", false, false, current);
    }
    document.dispatchEvent(ev);
  }

  var API = {
    STATE_NAMES: NAMES,
    OFFSHORE: OFFSHORE,
    zipToState: zipToState,

    get: function () { return current; },

    isOffshore: function () { return !!(current && OFFSHORE[current.state]); },

    // Full name plus ZIP, e.g. "Minnesota 55128".
    label: function () {
      if (!current) return "";
      var n = NAMES[current.state] || OFFSHORE[current.state] || current.state;
      return current.zip ? n + " " + current.zip : n;
    },

    set: function (zip) {
      var st = zipToState(zip);
      if (!st) return null;
      current = { zip: String(zip).replace(/\D/g, "").slice(0, 5), state: st, ts: Date.now() };
      write(current);
      broadcast();
      return current;
    },

    setState: function (st) {
      if (!NAMES[st] && !OFFSHORE[st]) return null;
      current = { zip: "", state: st, ts: Date.now() };
      write(current);
      broadcast();
      return current;
    },

    clear: function () {
      current = null;
      try { localStorage.removeItem(KEY); localStorage.removeItem(LEGACY_KEY); } catch (e) {}
      broadcast();
    }
  };

  window.USDORegion = API;

  // Keep other open tabs in step.
  window.addEventListener("storage", function (e) {
    if (e.key === KEY) { current = read(); broadcast(); }
  });

  /* ---------- header bar ---------- */

  function initBar(bar) {
    if (bar.getAttribute("data-usdo-ready")) return;
    bar.setAttribute("data-usdo-ready", "1");

    var label = bar.querySelector("[data-usdo-label]");
    var toggle = bar.querySelector("[data-usdo-toggle]");
    var form = bar.querySelector("[data-usdo-form]");
    var zip = bar.querySelector(".usdo-region__zip");
    var go = bar.querySelector(".usdo-region__go");
    var clear = bar.querySelector("[data-usdo-clear]");
    var err = bar.querySelector("[data-usdo-error]");
    if (!label || !toggle || !form || !zip || !go) return;

    var prompt = bar.getAttribute("data-prompt") || "See what's in stock near you";

    function render() {
      var r = API.get();
      if (r) {
        label.textContent = "Shipping to " + API.label();
        toggle.textContent = "Change";
        if (clear) clear.hidden = false;
      } else {
        label.textContent = prompt;
        toggle.textContent = "Set ZIP code";
        if (clear) clear.hidden = true;
      }
      bar.hidden = false;
    }

    function submit() {
      var r = API.set(zip.value);
      if (!r) {
        zip.setAttribute("aria-invalid", "true");
        if (err) { err.hidden = false; err.textContent = "That ZIP code isn't one we recognize."; }
        zip.focus();
        return;
      }
      zip.removeAttribute("aria-invalid");
      if (err) err.hidden = true;
      form.hidden = true;
    }

    toggle.addEventListener("click", function () {
      form.hidden = !form.hidden;
      if (!form.hidden) {
        var r = API.get();
        if (r && r.zip) zip.value = r.zip;
        zip.focus();
      }
    });
    go.addEventListener("click", submit);
    zip.addEventListener("keydown", function (e) {
      if (e.key === "Enter") { e.preventDefault(); submit(); }
    });
    if (clear) {
      clear.addEventListener("click", function () {
        API.clear();
        zip.value = "";
        form.hidden = true;
        if (err) err.hidden = true;
      });
    }

    document.addEventListener("usdo:region", render);
    render();
  }

  function boot() {
    var bars = document.querySelectorAll("[data-usdo-region]");
    for (var i = 0; i < bars.length; i++) initBar(bars[i]);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else { boot(); }

  // The theme editor re-renders sections without a page load.
  document.addEventListener("shopify:section:load", boot);
})();
